/**
 * ルーターパス定義
 */
export enum RouterPath {
  index = '/',
  login = '/login',
  register = '/register',
  mfaVerify = '/mfa-verify',
  passwordResetRequest = '/password-reset-request',
  passwordResetConfirm = '/password-reset-confirm',
  accountWithdrawal = '/account-withdrawal',
  profile = '/profile',
  contact = '/resume/contact',
  educationalBackground1 = '/resume/educational-background/1',
  educationalBackground2 = '/resume/educational-background/2',
  history = '/resume/history',
  historyComment = '/resume/history-comment',
  inputStatus = '/resume/input-status',
  nextCareer = '/resume/next-career',
  otherActivity = '/resume/other-activity',
  project = '/resume/project',
  selectMode = '/resume/select-mode',
  skill1 = '/resume/skill/1',
  skill2 = '/resume/skill/2',
  careerSummary = '/resume/summary',
  faq = '/faq',
  themeTest = '/theme-test',
  exportImport = '/data/export-import',
  // 履歴書関連のパス
  rirekishoBasicInfo = '/rirekisho/basic-info',
  rirekishoPhoto = '/rirekisho/photo',
  rirekishoAddress = '/rirekisho/address',
  rirekishoContact = '/rirekisho/contact',
  rirekishoHistory = '/rirekisho/history',
  rirekishoLicense = '/rirekisho/license',
  rirekishoMotivation = '/rirekisho/motivation',
  rirekishoPersonalRequests = '/rirekisho/personal-requests',
  rirekishoSignature = '/rirekisho/signature',
  rirekishoInputStatus = '/rirekisho/input-status',
}
